// src/components/LoginForm.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import "../styles/components/Login.css";
import logo from "../assets/logo.png";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function LoginForm() {
  const [email, setEmail]         = useState('');
  const [password, setPassword]   = useState('');
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const { login }                 = useAuth();
  const navigate                  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      // if your API returns 401 for bad creds:
      if (res.status === 401) {
        const err = await res.json();
        setError(err.message || 'Invalid credentials.');
      } else if (!res.ok) {
        // some other server error
        setError('Login failed. Please try again.');
      } else {
        const data = await res.json();
        if (data.success) {
          // store user in context / localStorage etc.
          login(data.user);
          // redirect based on role
          navigate(data.user.USER_ROLE_ID === 1 ? '/admin' : '/dashboard');
        } else {
          setError(data.message || 'Invalid credentials.');
        }
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Login failed. Please check your network connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <img src={logo} alt="Rest Boutique Logo" className="login-logo" />
        <h1 className="login-title">Welcome back</h1>

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            disabled={loading}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
            required
          />
          {error && <div className="login-error">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in…' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
}
